<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" width="604" v-model="dialog" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        THÊM MỚI NGƯỜI DÙNG
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon @click="cancel" class="white--text">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            class="required mt-8"
            :rules="[$rules.required]"
            v-model="name"
            label="Họ và Tên"
            @input="nameLostFocus()"
            @blur="nameLostFocus()"
            outlined
            dense
          ></v-text-field>
          <v-text-field outlined v-model="username" label="Tài khoản" dense disabled></v-text-field>
          <v-select
            :items="filteredRoles"
            label="Vai trò"
            item-value="id"
            item-text="description"
            v-model="role"
            outlined
            dense
            class="required"
            :rules="[$rules.required]"
          ></v-select>

          <v-text-field
            v-model="email"
            label="Email"
            :rules="[$rules.required, $rules.email]"
            class="required"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="password"
            label="Mật khẩu"
            :append-icon="show ? 'visibility' : 'visibility_off'"
            :rules="[$rules.nospace, $rules.required, $rules.minLength(6)]"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            class="required"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            v-model="password2"
            label="Nhập lại mật khẩu"
            :append-icon="show2 ? 'visibility' : 'visibility_off'"
            :rules="[$rules.nospace, $rules.required, $rules.minLength(6), $rules.passInputAgain(password2, password)]"
            :type="show2 ? 'text' : 'password'"
            @click:append="show2 = !show2"
            class="required"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            outlined
            v-model="phone"
            label="Số điện thoại"
            :rules="[$rules.required, $rules.phone]"
            class="required"
            dense
          ></v-text-field>

          <div class="ml-1">
            Ảnh đại diện
          </div>
          <v-row class="mt-4 mb-2 ml-1">
            <div class="image-input" :style="{ 'background-image': `url(${imageData})` }" @click="chooseImage">
              <span v-if="!imageData" class="placeholder">
                Tải ảnh lên
              </span>
              <input
                class="file-input"
                ref="fileInput"
                type="file"
                accept="image/png, image/jpeg, image/bmp"
                @input="onChange"
              />
            </div>
            <v-btn icon v-if="imageData">
              <v-icon @click="removeImage" color="grey">close</v-icon>
            </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="isLoading" depressed class="ma-2" color="primary" medium @click="save" :disabled="isLoading">
          <span>Lưu</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import utils from '@/plugins/utils'
import { User } from '../../plugins/api'
import { textHelpers } from '@/helpers/TextHelper.js'
import mixins from './helper/mixins'

export default {
  data() {
    return {
      dialog: false,
      loading: 0,
      name: '',
      phone: '',
      email: '',
      lastemail: '',
      username: this.username,
      username_indexing: this.username_indexing,
      username_no: this.username_no,
      role: '',
      show: false,
      show2: false,
      password: '',
      emailError: '',
      password2: '',
      // rules: {
      //   required: value => !!value || 'Required.',
      //   min: v => v.length >= 6 || 'Mật khẩu ít nhất 6 ký tự',
      //   email: v => /.+@.+/.test(v) || 'E-mail must be valid',
      //   passInputAgain: v => !v || v === this.password || 'Mật khẩu không khớp'
      // },
      avatar: '',
      imageData: null
    }
  },
  props: {
    state: Boolean
  },
  computed: {
    ...mapState('role', ['roles']),
    isLoading() {
      return this.loading > 0
    },
    staffName() {
      return textHelpers.removeSpaces(this.name)
    }
  },
  methods: {
    ...mapActions('user', ['generateUserName', 'validateEmail']),
    ...mapActions('staff', ['createStaff', 'uploadAvatar']),
    async save() {
      if (this.$refs.form.validate()) {
        if (!this.username || !this.username_indexing) {
          this.nameLostFocus()
        }
        const users = await User.search({ email: this.email, _limit: 1 })
        if (users.length > 0) {
          this.$alert.error('Email này đã được sử dụng')
          return
        }

        this.$loading.active = true
        try {
          const data = {
            name: this.staffName,
            phone: this.phone,
            username: this.username,
            username_indexing: this.username_indexing,
            username_no: this.username_no,
            status: 'active',
            role: this.role,
            email: this.email,
            password: this.password,
            tags: utils.clearUnicode(this.staffName) + '|' + this.username,
            nameToNumber: utils.generateNameToNumber(utils.generateNameToSort(this.staffName))
          }
          const staff = await this.createStaff(data)

          if (this.avatar) {
            let formData = new FormData()
            formData.append('files', this.avatar)
            formData.append('refId', staff.id)
            formData.append('ref', 'staff')
            formData.append('field', 'avatar')
            await this.uploadAvatar(formData)
          }

          this.dialog = false
          this.reset()
          this.$refs.form.resetValidation()
          this.$emit('done')
        } catch (error) {
          this.$alert.addError(error)
        } finally {
          this.$loading.active = false
        }
      }
    },
    chooseImage() {
      this.$refs.fileInput.click()
    },
    removeImage() {
      this.avatar = null
      this.imageData = null
    },
    onChange() {
      const input = this.$refs.fileInput
      const files = input.files
      if (files && files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(files[0])
        this.avatar = files[0]
      }
    },
    async nameLostFocus() {
      const {
        username,
        // eslint-disable-next-line
        username_indexing,
        // eslint-disable-next-line
        username_no
      } = await this.generateUserName(this.staffName)
      this.username = username
      // eslint-disable-next-line
      this.username_indexing = username_indexing
      // eslint-disable-next-line
      this.username_no = username_no
    },
    async emailLostFocus() {
      try {
        this.loading += 1
        if (this.email !== this.lastemail) {
          this.emailError = await this.validateEmail(this.email)
        }
        this.lastemail = this.email
      } finally {
        this.loading -= 1
      }
    },
    cancel() {
      this.dialog = false
      this.reset()
      this.$refs.form.resetValidation()
    },
    reset() {
      this.name = ''
      this.username = ''
      this.phone = ''
      this.password = ''
      this.password2 = ''
      this.email = ''
      this.emailError = ''
      this.role = null
      this.removeImage()
    }
  },
  watch: {
    state(state) {
      this.dialog = true
      this.reset()
    }
  },
  mixins: [mixins]
}
</script>
<style scoped>
.image-input {
  display: block;
  width: 200px;
  height: 200px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.placeholder {
  background: #f0f0f0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: Helvetica;
}
.placeholder:hover {
  background: #e0e0e0;
}

.file-input {
  display: none;
}
</style>
